import { Injectable, HostListener } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';

// Menu
export interface Menu {
	path?: string;
	title?: string;
	icon?: string;
	type?: string;
	badgeType?: string;
	badgeValue?: string;
	active?: boolean;
	bookmark?: boolean;
	children?: Menu[];
}

@Injectable({
	providedIn: 'root'
})

export class NavService {

	public screenWidth: any
	public collapseSidebar: boolean = false
	public fullScreen = false;

	constructor() {
		this.onResize();
		if (this.screenWidth < 991) {
			this.collapseSidebar = true
		}
	}

	// Windows width
	@HostListener('window:resize', ['$event'])
	onResize(event?: any) {
		this.screenWidth = window.innerWidth;
	}

	MENUITEMS: Menu[] = [
		{
			path: "/content/pricing", title: 'Dashboard', icon: 'home', type: 'link', active: false, badgeType: 'primary',
		},
		{
			title: 'Administración', icon: 'unlock', type: 'sub', active: false, children: [
				//{ path: 'authentication/login/image', title: 'Login', type: 'extTabLink' },
				{ path: '/content/admin/useradmin/index', title: 'Administradores', type: 'link' },
				{ path: '/content/admin/suscription/index', title: 'Suscripcion', type: 'link' },
				{ path: '/content/admin/distributor/index', title: 'Distribuidores', type: 'link' },
				{ path: '/content/admin/sucursal/index', title: 'Sucursales', type: 'link' },
				//{ path: 'authentication/unlockuser', title: 'Bloqueo usuario', type: 'extTabLink' },
				//{ path: 'authentication/forgetpassword', title: 'Olvidó su contraseña', type: 'extTabLink' },
				//{ path: 'authentication/resetpassword', title: 'Restablecer la contraseña', type: 'extTabLink' }
			]
		},
		{
			title: 'Descargar licencia', icon: 'download',path: 'https://backupsitric.blob.core.windows.net/programas/SITRIC.zip?sp=r&st=2025-02-06T23:38:45Z&se=2026-02-07T07:38:45Z&sv=2022-11-02&sr=b&sig=9mZE6v34qBljze%2BULcr%2F4LGZqkht%2BOBQoep2s2tURpE%3D', type: 'extTabLink', active: false,
		}
	]
	// Array
	items = new BehaviorSubject<Menu[]>(this.MENUITEMS);


}
